import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { findTickInterval } from '../utils';
export var d3Time = function d3Time(min, max, count, interval, utc) {
  var r = min > max;
  var lo = r ? max : min;
  var hi = r ? min : max;
  var _findTickInterval = findTickInterval(lo, hi, count, interval, utc),
    _findTickInterval2 = _slicedToArray(_findTickInterval, 2),
    tickInterval = _findTickInterval2[0],
    step = _findTickInterval2[1];
  var ticks = tickInterval.range(lo, new Date(+hi + 1), step, true);
  return r ? ticks.reverse() : ticks;
};